export default "__VITE_ASSET__DIxFXaQz__"